require('./liquidationHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ constants
const { EURO_TEXT } = require('constants/index');

class LiquidationHeader extends React.Component {
    buildLiquidationTotal() {
        const { total } = this.props;
        let dataToRender = null;

        if (total) {
            const amountObject = {
                amount: total,
                currency: EURO_TEXT // @ hardcoded
            };
            const plainAmountObject = getPlainAmountObject(amountObject);

            dataToRender = (
                <div className="liquidation-header__box-right">
                    <span className="liquidation-header__text-total">
                        <FormattedText value="liquidation-liquidationTotal"/>
                    </span>
                    <p className="liquidation-header__value-total">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </p>
                </div>
            );
        }

        return dataToRender;
    }

    render() {
        const liquidationTotal = this.buildLiquidationTotal();

        return (
            <section className="liquidation-header">
                <div className="liquidation-header__box-left">
                    <span className="liquidation-header__text-type">
                        <FormattedText value="liquidation-liquidationType"/>
                    </span>
                    <p className="liquidation-header__value-type">{this.props.type}</p>
                </div>
                {liquidationTotal}
            </section>
        );
    }

}

LiquidationHeader.propTypes = {
    total: PropTypes.number,
    type: PropTypes.string
};

module.exports = LiquidationHeader;